// import React from 'react'
// import axios from 'axios'
// import {toAbsoluteUrl} from '../../AssetHelpers'
// import { useLocation } from 'react-router-dom'

// function UploadImage({label, name, formik, filetype = ''}: any) {
//   // console.log({ test: formik.values[name] })
//   // const handleFileChange = async (event) => {
//   //   const file = event.target.files[0]
//   //   console.log('file is', file)
//   //   const formData = new FormData()
//   //   formData.append('file', file)

//   //   const response = await axios.post(process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '', formData, {
//   //     headers: {
//   //       'Content-Type': 'multipart/form-data',
//   //       token:
//   //         'Bearer ${token}',
//   //     },
//   //   })

//   //   if (response?.data?.data?.name) {
//   //     formik.setFieldValue(name, response.data.data.name)
//   //   }
//   // }


//   const location = useLocation()
//   const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point')

//   const handleFileChange = async (event) => {
//     const file = event.target.files[0]
//     console.log('=== File Upload Debug ===')
//     console.log('Selected file:', file)
//     console.log('File type:', file.type)
//     console.log('Field name:', name)
//     console.log('=========================')

//     const formData = new FormData()
//     formData.append('file', file)
//     const response = await axios.post(process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '', formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//         token: 'Bearer ${token}',
//       },
//     })

//     if (response?.data?.data?.name) {
//       console.log('Setting field values:', {
//         [`${name}`]: response.data.data.name,
//         [`${name}_type`]: file.type
//       })
//       formik.setFieldValue(name, response.data.data.name)
//       formik.setFieldValue(`${name}_type`, file.type)
//     }
//   }

//   const getFileIcon = (filename, filetype) => {
//     console.log('=== DEBUG getFileIcon ===')
//     console.log('filename:', filename)
//     console.log('filetype prop:', filetype)
//     console.log('name:', name)
//     console.log('All formik values:', formik.values)
//     console.log('Stored file type key:', `${name}_type`)
//     console.log('Stored file type value:', formik.values[`${name}_type`])
//     console.log('========================')

//     if (!filename) {
//       return ''
//     }

//     const storedFileType = formik.values[`${name}_type`]

//     // Only show PDF icon if it's actually a PDF
//     if (storedFileType === 'application/pdf') {
//       return toAbsoluteUrl('/media/svg/files/pdf.svg')
//     }

//     // For all other files (including images), return the filename
//     return filename
//   }


//   // const getFileIcon = (filename, filetype) => {
//   //   console.log('getFileIcon called with:', { filename, filetype })

//   //   if (!filename) {
//   //     console.log('No filename, returning empty')
//   //     return ''
//   //   }

//   //   if (filetype === 'pdf') {
//   //     const pdfIcon = toAbsoluteUrl('/media/svg/files/pdf.svg')
//   //     console.log('PDF filetype, returning:', pdfIcon)
//   //     return pdfIcon
//   //   }

//   //   console.log('Falling back to filename:', filename)
//   //   return filename
//   // }
//   const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')

//   // Set allowed file types based on filetype prop
//   const allowedFileTypes = filetype === 'pdf' ? '.pdf' : '.png, .jpg, .jpeg'

//   return (
//     <div className='fv-row mb-7'>
//       <label className='d-block fw-bold fs-6 mb-5'>{label}</label>
//       <div
//         className='image-input image-input-outline'
//         data-kt-image-input='true'
//         style={{backgroundImage: `url('${blankImg}')`}}
//       >

//         {/* <div
//           className='image-input-wrapper w-125px h-125px'
//           // style={{
//           //   backgroundImage: `url('${
//           //     filetype === 'pdf'
//           //       ? formik.values[name]
//           //         ? toAbsoluteUrl('/media/svg/files/pdf.svg')
//           //         : ''
//           //       : formik.values[name]
//           //   }')`,
//           // }}
//           style={{
//             backgroundImage: `url('${getFileIcon(formik.values[name], filetype)}')`,
//           }}
//         ></div> */}



//         {isCollectionPointPath ? (
//           <div className='image-input-wrapper w-125px h-125px' style={{ position: 'relative', overflow: 'hidden' }}>
//             {formik.values[name] && (
//               <img
//                 src={formik.values[name]}
//                 alt="Document"
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   objectFit: 'contain'
//                 }}
//                 onError={(e) => {
//                   (e.target as HTMLImageElement).src = toAbsoluteUrl('/media/svg/files/pdf.svg')
//                 }}
//               />
//             )}
//           </div>
//         ) : (
//           <div
//             className='image-input-wrapper w-125px h-125px'
//             style={{
//               backgroundImage: `url('${getFileIcon(formik.values[name], filetype)}')`,
//             }}
//           ></div>
//         )}


//         <label
//           className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
//           data-kt-image-input-action='change'
//           data-bs-toggle='tooltip'
//           title='Change avatar'
//         >
//           <i className='bi bi-pencil-fill fs-7'></i>
//           {/* <input type='file' name='avatar' accept={allowedFileTypes} onChange={handleFileChange} />
//            */}
//           <input type='file' name='avatar' accept='*/*' onChange={handleFileChange} />
//           <input type='hidden' name='avatar_remove' />
//         </label>
//         <span
//           className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
//           data-kt-image-input-action='cancel'
//           data-bs-toggle='tooltip'
//           title='Cancel avatar'
//         >
//           <i className='bi bi-x fs-2'></i>
//         </span>
//       </div>
//       {/* <div className='form-text '>
//         Allowed file types: {filetype === 'pdf' ? 'pdf' : 'png, jpg, jpeg'}.
//       </div> */}
//       <div className='form-text '>
//         Allowed file types: All file types accepted.
//       </div>
//     </div>
//   )
// }

// export default UploadImage



import React, { useState } from 'react'
import axios from 'axios'
import { toAbsoluteUrl } from '../../AssetHelpers'
import { useLocation } from 'react-router-dom'

function UploadImage({ label, name, formik, filetype = '' }: any) {
  const [fileLoadError, setFileLoadError] = useState<{ [key: string]: boolean }>({});
  const [isUploading, setIsUploading] = useState(false)

  const handleFileChange = async (event) => {
    const file = event.target.files[0]
    if (!file) return

    console.log('=== File Upload Debug ===')
    console.log('Selected file:', file)
    console.log('Field name:', name)

    setIsUploading(true)
    const authData = localStorage.getItem('kt-auth-react-v')
    const token = authData ? JSON.parse(authData).data.token : null

    // if (!token) {
    //   setIsUploading(false)
    //   throw new Error('Authentication token not found')
    // }

    try {
      const formData = new FormData()
      formData.append('file', file)
      const response = await axios.post(process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          token: `Bearer ${token}`,
        },
      })

      if (response?.data?.data?.name) {
        formik.setFieldValue(name, response.data.data.name)
        setFileLoadError(prev => ({
          ...prev,
          [name]: false
        }));
      }
    } catch (err) {
      console.error('Upload failed', err)
    } finally {
      setIsUploading(false)
    }
  }

  const handleImageError = () => {
    setFileLoadError(prev => ({
      ...prev,
      [name]: true
    }));
  };

  const fieldValue = formik.getFieldProps ? formik.getFieldProps(name).value : formik.values[name];
  const isPdf = fileLoadError[name] || (fieldValue && fieldValue.toLowerCase().endsWith('.pdf'));

  return (
    <div className="flex flex-col gap-2 w-full">
      <label className="text-[13px] font-bold text-gray-700 tracking-wide">
        {label}
      </label>

      <div className="relative group w-full">
        <label className={`
          flex flex-col sm:flex-row items-center gap-4 p-4 border border-dashed rounded-2xl cursor-pointer transition-all duration-300 bg-white
          ${fieldValue ? 'border-emerald-300 bg-emerald-50/10' : 'border-gray-300 hover:border-blue-400 hover:bg-gray-50/50'}
        `}>
          <input
            type="file"
            accept="image/*,application/pdf"
            onChange={handleFileChange}
            className="hidden"
            disabled={isUploading}
          />

          <div className={`
            w-12 h-12 rounded-full flex items-center justify-center transition-colors duration-300 flex-shrink-0
            ${fieldValue ? 'bg-emerald-50 text-emerald-600' : 'bg-blue-50 text-blue-600'}
          `}>
            {isUploading ? (
              <svg className="animate-spin h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
            ) : fieldValue ? (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            )}
          </div>

          <div className="flex-1 flex flex-col text-center sm:text-left overflow-hidden">
            {isUploading ? (
              <span className="text-sm font-semibold text-gray-700">Uploading file...</span>
            ) : fieldValue ? (
              <>
                <span className="text-sm font-semibold text-emerald-700">Document Uploaded Successfully</span>
                <span className="text-xs text-gray-400 truncate max-w-xs sm:max-w-md">{fieldValue}</span>
              </>
            ) : (
              <>
                <span className="text-sm font-semibold text-gray-700">Click to upload document</span>
                <span className="text-xs text-gray-400">PDF, PNG, JPG, or JPEG</span>
              </>
            )}
          </div>

          {fieldValue && !isUploading && (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                formik.setFieldValue(name, '');
              }}
              className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors flex-shrink-0"
              title="Remove document"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          )}
        </label>

        {fieldValue && !isUploading && (
          <div className="mt-2 flex items-center gap-3">
            {isPdf ? (
              <div className="flex items-center gap-2 px-3 py-1.5 bg-red-50 border border-red-100 rounded-lg text-red-700">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
                <span className="text-xs font-semibold">PDF Document</span>
              </div>
            ) : (
              <div className="relative w-24 h-16 rounded-lg overflow-hidden border border-gray-200 bg-gray-50 flex items-center justify-center">
                <img
                  src={fieldValue}
                  alt="Preview"
                  className="max-w-full max-h-full object-contain"
                  onError={handleImageError}
                />
              </div>
            )}
            <a
              href={fieldValue}
              target="_blank"
              rel="noreferrer"
              className="text-xs text-blue-600 font-bold hover:underline"
            >
              View Document
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export default UploadImage